import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar'
import Card from './components/Card'

import './App.css';
import Axios from 'axios';
import { Grid, Container, LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    container: {
        paddingTop: 80,
    },
    progress: {
        top: 65,
        zIndex: 100
    }
}));

function App() {
    const classes = useStyles();

    const [state, setState] = useState([])
    const [search, setSearch] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        Axios.get('https://th.frb-data.dk/').then((res) => {
            setLoading(false)
            let keys = Object.keys(res.data);
            let formated = keys.map(x => { return { title: x, ...res.data[x] } })
            let sorted = formated.sort((a,b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1)
            setState(sorted)
        })
    }, [])

    const searchHandler = (e) => {
        console.log(e.target.value)
        let str = e.target.value
        setTimeout(() => {
            setSearch(str)  
        }, 50);
    }

    return (
        <div className="App">
            {loading ? <LinearProgress className={classes.progress} /> : null}
            <Navbar changed={searchHandler}/>
            <Container maxWidth="xl">
                <Grid 
                    container
                    spacing={2}
                    className={classes.container}
                >
                    {state.filter(x => x.title.toLowerCase().includes(search.toLowerCase())).map(item => (
                        <Grid item lg={2} md={3} sm={4} xs={12} key={item.title}>
                            <Card
                                title={item.title}
                                meta={item.meta}
                                map={item.interactive}
                            >
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </div>
    );
}

export default App;
